(function() {
    window.addEventListener("load", function() {
        improveAnchorFunctionality();
        printMyWebPageLinks();
    });

    function improveAnchorFunctionality() {
        let url = window.location.href;
        if (url.indexOf("#") !== -1) {
            let anchor = url.substring(url.indexOf("#") + 1),
                element = document.getElementById(anchor);
            if (element) {
                setTimeout(function () {
                    element.scrollIntoView();
                }, 0);

            }
        }
    }

    function printMyWebPageLinks(){  
        const printLinks = document.querySelectorAll('.__js-print-page-link'); 
        printLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                console.log('link');
                e.preventDefault();
                window.print();
            });
        }); 
    } 
})();



class QuickViewTriggerInitializer extends HTMLElement {
    constructor() {
        super();

        this.closest(this.dataset.parent)
            .querySelectorAll(this.dataset.trigger).forEach(trigger => {
            const wrapper = this.closest('.quick-view-snippet__wrapper');
            const sliderElement = this.closest('.keen-slider');
            if (sliderElement) {
                sliderElement.appendChild(wrapper);
            }

            const drawer = wrapper.querySelector('quick-view-drawer');
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                if (drawer) {
                    drawer.querySelector('summary').click();
                }
            });
        });
    }
}
customElements.define('quick-view-trigger', QuickViewTriggerInitializer);


